module.exports = "https://static.wagwalking.com/_next/static/images/mobile-placeholder-f4a136875a89ccf9141d5aa3a9ca8d25.jpg";